import { useTranslation } from 'react-i18next';
import { JOB_FORM_RULES_ENDPOINT, JOB_STATUS_TRANSITION_ACTIONS_ENDPOINT } from '../../../../consts';
import { useHasPermission } from '../../../../contexts/auth';
import { useListCount } from '../../../../hooks/useListCount';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import { TenantSection } from './tenantSection.component';

/** What the workspace does on its own: billing runs and the rules jobs are held to. */
export const TenantAutomationSection = () => {
  const { t } = useTranslation();
  const canViewSettlementAutomation = useHasPermission('settlement.view_contract');
  const canViewTransitionActions = useHasPermission('service.view_jobstatustransitionaction');
  const transitionActionsCount = useListCount(
    JOB_STATUS_TRANSITION_ACTIONS_ENDPOINT,
    canViewTransitionActions
  );
  const canViewJobFormRules = useHasPermission('service.view_jobformrule');
  const jobFormRulesCount = useListCount(JOB_FORM_RULES_ENDPOINT, canViewJobFormRules);

  return (
    <TenantSection
      tabs={[
        ...(canViewSettlementAutomation
          ? [{ key: 'settlements', label: t('Settlements'), path: TENANT_ROUTES.automation }]
          : []),
        ...(canViewTransitionActions
          ? [
              {
                key: 'job-status-actions',
                label: t('Job status actions'),
                path: TENANT_ROUTES.jobStatusActions,
                count: transitionActionsCount,
              },
            ]
          : []),
        ...(canViewJobFormRules
          ? [
              {
                key: 'job-form-rules',
                label: t('Job form rules'),
                path: TENANT_ROUTES.jobFormRules,
                count: jobFormRulesCount,
              },
            ]
          : []),
      ]}
    />
  );
};
